import { AwsSnsAdapter } from "../../adpters/Aws/aws-sns.adapter";
import { User } from "../../../gateway/User/User";
import _ from "lodash";
import { UserDataAdapter } from "../../adpters/UserDataAdapter";

export class EventScoreService {
    constructor() {
        this.name = "nucont-score";
        this.AwsSnsAdapter = new AwsSnsAdapter();
        this.User = new User();
    }

    async onReportShared(accountingId, companyId, source) {
        if (!this._isAccountingUser()) return;

        this._publish({
            topicArn: this.name,
            accountingId,
            companyId,
            source,
            eventType: "reportShared"
        });
    }

    async onReportDownloaded(accountingId, companyId, source) {
        if (!this._isAccountingUser()) return;

        this._publish({
            topicArn: this.name,
            accountingId,
            companyId,
            source,
            eventType: "reportDownloaded"
        });
    }

    async onReportShowed(accountingId, companyId, source) {
        if (!this._isCompanyUser()) return;

        this._publish({
            topicArn: this.name,
            accountingId,
            companyId,
            source,
            eventType: "reportShowed"
        });
    }

    _publish({ topicArn, accountingId, companyId, source, eventType }) {
        const user = new UserDataAdapter().user();
        if (!accountingId || !companyId || !source || !eventType || !user?._id)
            return;
        const message = JSON.stringify({
            accountingId,
            companyId,
            source,
            eventType,
            time: new Date(),
            userId: user._id
        });
        console.info("message:", message);
        this.AwsSnsAdapter.publish(topicArn, message);
    }

    _isAccountingUser() {
        const user = new UserDataAdapter().user();
        const accountingUsers = [
            "Contabilidade",
            "ContabilidadeTrial",
            "ContabilidadeTrialPro",
            "Contabil",
            "Comercial",
            "Fiscal",
            "Pessoal",
            "Financeiro",
            "Gestor",
            "Pessoal e Fiscal",
            "Empresa",
            "Anonimo"
        ];
        if (user) {
            const hasPermission = this.User.checkPermission({
                roles: _.get(user, "roles"),
                granted: accountingUsers
            });
            if (hasPermission) return true;
        }
        return false;
    }

    _isCompanyUser() {
        const user = new UserDataAdapter().user();
        const accountingUsers = ["Empresa", "Anonimo"];

        if (user) {
            const hasPermission = this.User.checkPermission({
                roles: _.get(user, "roles"),
                granted: accountingUsers
            });

            if (hasPermission) return true;
        }

        return false;
    }
}
